import { Configs } from '../../models/status-tracker/aem/aem-status-tracker.interfaces';
import { CommonRequest } from '../../models/status-tracker/api/api-status-tracker.interfaces';
import { CommonConstants } from '../../models/status-tracker/status-tracker.constants';

export const getServiceConfiguration = (configs: Configs): CommonRequest => {
  const {
    carrierCode = '',
    timeout = CommonConstants.TIMEOUT,
    retry = 0
  } = configs;
  return {
    carrierCode,
    timeout,
    retry
  };
};
